export default __webpack_public_path__ + "static/media/10 1.5a70124f.svg";